import {IVersion} from "./Revisions";
import {Accordion, AccordionActions, AccordionDetails, AccordionSummary, Box, Button, Typography} from "@mui/material";
import {RevisionDifference} from "./RevisionDifference";
import React, {useContext} from "react";
import {connect} from "react-redux";
import {selectLocks, selectUsers} from "../../redux/selectors/firebase";
import {Users} from "../../redux/types/firebase";
import makeStyles from "@mui/styles/makeStyles";
import {Locks} from "../navbar/StateLock";
import {selectUserId} from "../../redux/selectors/editor";
import {FirebaseContext} from "../firebase/FirebaseProvider";

const useStyles = makeStyles((theme) => ({
    columnDate: {
        width: 160
    },
    columnUser: {
        width: 200
    },
}));
interface IRevisionVersionDetails {
    expanded: string
    locks: Locks
    previous: IVersion
    project: string
    setExpanded: (expanded: string) => void
    state?: any
    stateKey: string
    user: string
    users: Users
    versionKey: string
    version: IVersion
}
function RevisionVersionDetails({expanded, locks, previous, project, setExpanded, state, stateKey, user, users,
                                    versionKey, version}: IRevisionVersionDetails) {
    const classes = useStyles();
    const {push, removeLock, set, setLock} = useContext(FirebaseContext);
    const handleRevertClick = () => {
        setLock(project, stateKey, user)
            .then(() => set(`nodes/${project}/${stateKey}`, version.data))
            .then(() => push(`revisions/${project}/${stateKey}`, {
                created: Date.now() / 1000,
                data: version.data,
                message: `Went back to revision ${stateKey}`,
                user
            }))
            .then(() => removeLock(project, stateKey))
    }
    const locked = locks[stateKey] && locks[stateKey].user !== user;
    const revertDisabled = locked || state === undefined || JSON.stringify(state) === JSON.stringify(version.data);

    return (
        <Accordion expanded={expanded === versionKey}
                   onChange={() => setExpanded(expanded === versionKey ? "" : versionKey)} sx={{flexGrow: 1}}>
            <AccordionSummary sx={{flexGrow: 1}}>
                <Box display="flex" sx={{flexGrow: 1}}>
                    <Typography className={classes.columnUser}>
                        {users[version.user]?.name || "Unknown"}
                    </Typography>
                    <Box flexGrow={1}>
                        <Typography>{version.message || ""}</Typography>
                    </Box>
                    <Typography className={classes.columnDate}>
                        {new Date(version.created * 1000).toLocaleString()}
                    </Typography>
                </Box>
            </AccordionSummary>
            <AccordionDetails>
                <RevisionDifference previous={previous} version={version}/>
            </AccordionDetails>
            <AccordionActions>
                <Button color="primary" disabled={revertDisabled} onClick={handleRevertClick} variant="contained">
                    Revert
                </Button>
            </AccordionActions>
        </Accordion>
    );
}
const mapStateToProps = (store: never) => ({
    locks: selectLocks(store),
    user: selectUserId(store),
    users: selectUsers(store) || {}
});

const connected = connect(mapStateToProps, {
})(RevisionVersionDetails);

export {connected as RevisionVersionDetails};